import { createContext } from 'react';
import { LeasingWidgetsProps } from './leasing-widgets-layout.types';

export const LeasingWidgetsContext = createContext(<LeasingWidgetsProps>({} as LeasingWidgetsProps));
